import React, { useState } from "react";

export default React.memo(function PlayerImage({ className, id, alt }) {
    const [dynamicClassName, setDynamicClassName] = useState(className);
    const src = `https://s.hs-data.com/gfx/person/cropped/400x400/${parseInt(id)}.png`
    return (
        <img
            src={src}
            id={`bild-player-id-${id}`}
            className={dynamicClassName}
            alt={alt}
        />
    );
});
